import React, { useEffect, useRef } from "react"

/** Like `useEffect` but skips the initial render */
export function useUpdateEffect(effect: () => void, deps: React.DependencyList) {
  const isFirstRender = useRef(true)
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }
    effect()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
}
